import React, { Fragment, PureComponent } from "react";
import * as RBT from "react-bootstrap";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import io from "socket.io-client";
import * as Sentry from "@sentry/react";
import { autoassign, setLiveLeadCount } from '../../Store/actions/loginActions';
import { AJAX_REQUEST, GET_STORAGE, SOCKET_URL, IDLE_SESSION_TIMEOUT, sentryConfig, sentryErrorLog, SET_STORAGE } from "../../Constants/AppConstants";
import ContactList from "./ContactList";
import Conversations from "./Conversations";

//class start
class Index extends PureComponent {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      rightContainerType: "autoAssign", // autoAssign, autoAssignUnavailable
      autoAssignSearching: false,
      socketConnectStatus: false,
      loadingConversation: false,
      liveLeadCount: 0,

      currentContactID: false,
      assignedContactID: false,
      currentGymOwnerID: false,
      assignedGymOwnerID: false,
      Socket: null,
      username: "",
      lco_id: "",
      connected: false,
      isAutoAssignable: false,

      // Settings
      pauseScheduleMessage: false,
      scheduleSoundUrl: '',
      isAutoAssigned: false,
      reconnectionErr: 1,
      leadCountSource: 'socket',

      autoAssigningText: 'Searching Available Lead...',
    }

    document.title = "Lead Manage - ALAN Live Chat Operator";
  }

  componentDidMount() {
    this._isMounted = true;

    this.getSettings();
  }

  componentWillUnmount() {
    this._isMounted = false;

    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.leadProcessStatus !== prevProps.leadProcessStatus) {
        if (this.props.leadProcessStatus === "done") {
          if (this._isMounted) {
            this.setState({
              currentContactID: false,
              assignedContactID: false,
              currentGymOwnerID: false,
              assignedGymOwnerID: false,
              loadingConversation: false,
              autoAssign: 'autoAssign'
            });
            setTimeout(() => {
              this.setState({
                autoAssignSearching: false
              });
            }, 1000);

          }
        }
      }

      if (this.props.isAutoAssignable !== prevProps.isAutoAssignable) {
        this.setState({
          isAutoAssignable: this.props.isAutoAssignable
        });
      }
    }
  }

  //get settings value
  getSettings = () => {
    AJAX_REQUEST("POST", "v2/operator/getSettings", {}).then(
      (results) => {
        if (parseInt(results.response.code) === 1000) {

          SET_STORAGE('settings', JSON.stringify(results.response.data));

          if (this._isMounted) {
            this.setState({
              pauseScheduleMessage: results.response.data ? results.response.data.pauseScheduleMessage : false,
              scheduleSoundUrl: results.response.data ? results.response.data.scheduleSoundUrl : '',
              leadCountSource: results.response.data && results.response.data.leadCountSource ? results.response.data.leadCountSource : 'socket',
            });
          }

          sentryConfig();

          this.checkExistingAutoAssign();
        }
        if (this._isMounted) {
          //load live lead count
          this.getLiveLeadCount();
        }
      }
    );
  }

  //get live lead count
  getLiveLeadCount = () => {
    //check source
    if (this.state.leadCountSource === 'socket') {
      let token = JSON.parse(GET_STORAGE("plu"))
        ? (JSON.parse(GET_STORAGE("plu")).token ? JSON.parse(GET_STORAGE("plu")).token : '')
        : "";
      const Socket = io(SOCKET_URL, { query: 'auth_token=' + token });
      //set state value
      this.setState({ Socket });

      Socket.on('error', (err) => {
        Sentry.captureMessage("Socket error", err);
        this.setState({ socketConnectStatus: false }, () => { this.getLiveLeadByAPI(); });
      });

      //set socket user name
      this.setSocketUsername();

      //socket login
      Socket.on("login", (data) => {
        if (data && data.socketId !== '') {
          //set state value
          this.setState({
            connected: true,
            isAutoAssignable: true,
          });
          this.props.autoassign(true);
          console.log("Socket Connected!", data.socketId);
        }
        else {
          //this.getLiveLeadByAPI();
          // console.log("Socket Connection Failed!");
        }
      });

      Socket.on("connect", () => {
        this.setState({
          socketConnectStatus: true
        });
        clearInterval(this.interval);
        this.interval = setInterval(() => { Socket.emit('totalLiveCount', this.state.lco_id); }, 1000);
      });

      Socket.on("reconnect", () => {
        Sentry.captureMessage("Socket have been reconnected");
        this.setState({ socketConnectStatus: true });
      });

      Socket.on("reconnect_error", () => {
        Sentry.captureMessage("Socket attempt to reconnect has failed");
        this.setState({ socketConnectStatus: false }, () => { this.getLiveLeadByAPI(); });
      });

      Socket.on("disconnect", () => {
        Sentry.captureMessage("Socket have been disconnected");
        this.setState({ socketConnectStatus: false }, () => { this.getLiveLeadByAPI(); });
      });

      Socket.on('totalLiveFoundNew', (leadCount) => {
        if (this.state.connected) {
          if (this.state.liveLeadCount !== leadCount) {
            this.setState({ liveLeadCount: leadCount }, () => { this.props.setLiveLeadCount(this.state.liveLeadCount); });
          }
          //lead count check, if more than 0 then call the auto assign
          if (this.state.currentContactID === false) {
            if (leadCount > 0) {
              // console.log('lead count founds by socket: ', leadCount);
              this.leadAutoAssigning();
            } else {
              this.setState({
                rightContainerType: 'autoAssignUnavailable'
              });
            }
          }
        }
      });
    } else {
      this.getLiveLeadByAPI();
    }

  }

  getLiveLeadByAPI = () => {
    if (this.state.socketConnectStatus === false) {
      //set state value
      this.setState({
        connected: true,
        isAutoAssignable: true
      });
      this.props.autoassign(true);

      //get lead count by api
      clearInterval(this.interval);
      this.interval = setInterval(() => { this.liveLeadCountByAPI(); }, 1000);
    }
  }

  //Get live lead count by API added by Farhad
  liveLeadCountByAPI = () => {
    if (this.state.socketConnectStatus === false) {
      //api call for new lead
      AJAX_REQUEST("POST", "v2/operator/getLiveLead", {}).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          let leadCount = results.response.data.lead_count;
          if (this.state.liveLeadCount !== leadCount) {
            this.setState({
              liveLeadCount: leadCount
            }, () => {
              this.props.setLiveLeadCount(this.state.liveLeadCount);
            });
          }
          if (this.state.currentContactID === false) {
            if (leadCount > 0) {
              //console.log('lead count founds by API: ', leadCount);
              this.leadAutoAssigning();
            } else {
              //set state value
              this.setState({
                rightContainerType: 'autoAssignUnavailable'
              });
            }
          }
        }
      });
    }
  }

  getLeadFromLatestReplies = (contactID, userID) => {
    this.setState({
      currentContactID: false,
      currentGymOwnerID: false,
      loadingConversation: true,
      rightContainerType: 'autoAssign',
      autoAssigningText: 'Loading the conversation...'
    });
    setTimeout(() => {
      this.setState({
        currentContactID: contactID,
        currentGymOwnerID: userID,
        autoAssigningText: 'Searching Available Lead...',
        isAutoAssigned: false,
      });
    }, 500);
  }

  //Lead auto assigning added by Farhad
  leadAutoAssigning = () => {
    if ((!this.state.autoAssignSearching) && (!this.state.currentContactID) && (this.state.connected) && (this.state.isAutoAssignable)) {
      // console.log('leadAutoAssigning calling', this.state.currentContactID);
      this.setState({
        rightContainerType: 'autoAssign',
        autoAssignSearching: true,
        isAutoAssigned: false,
      });
      //api call for new lead
      AJAX_REQUEST("POST", "v2/operator/getAutoAssignLead", {}).then((results) => {

        // Sentry Log create
        sentryErrorLog(results);

        if (parseInt(results.response.code) === 1000) {
          const data = results.response.data;
          //set state value
          this.setState({
            currentContactID: data.contact_id,
            assignedContactID: data.contact_id,
            currentGymOwnerID: data.user_id,
            assignedGymOwnerID: data.user_id,
            isAutoAssigned: true,
          });
          // this.setCurrentContact(data.contact_id, data.user_id, 'auto');
          localStorage.setItem("idleTimeLeft", IDLE_SESSION_TIMEOUT);
        } else {
          //set state value
          this.setState({
            autoAssignSearching: false,
            rightContainerType: 'autoAssignUnavailable'
          });
          localStorage.setItem("autoAssignInfo", JSON.stringify({}));
        }
      });
    }
  }

  checkExistingAutoAssign = () => {
    const autoAssignInfo = (localStorage.getItem("autoAssignInfo")) ? JSON.parse(localStorage.getItem("autoAssignInfo")) : [];
    if (autoAssignInfo && autoAssignInfo.assignedContactID && autoAssignInfo.assignedGymOwnerID) {
      this.setState({
        currentContactID: autoAssignInfo.assignedContactID,
        assignedContactID: autoAssignInfo.assignedContactID,
        currentGymOwnerID: autoAssignInfo.assignedGymOwnerID,
        assignedGymOwnerID: autoAssignInfo.assignedGymOwnerID,
        isAutoAssigned: true,
        rightContainerType: 'autoAssign',
        autoAssignSearching: true,
      });
      localStorage.setItem("idleTimeLeft", IDLE_SESSION_TIMEOUT);
    }
  }

  setSocketUsername = () => {
    if (this.state.Socket) {
      let plu = JSON.parse(GET_STORAGE("plu")) ? JSON.parse(GET_STORAGE("plu")) : '';
      let username = (plu) ? plu.email ? plu.email : '' : '';
      let lco_id = (plu) ? plu.user_id ? plu.user_id : '' : '';
      this.setState({
        username,
        lco_id
      });
      if (username) {
        this.state.Socket.emit("add user", username);
      }
    }
  };

  newSelectedPlay = () => {
    if (!this.props.isMute) {
      if (this.new_selected_play) {
        this.new_selected_play.play();
      }
    }
  };

  disconnectSocket = (e) => {
    e.preventDefault();
    localStorage.setItem("user_id", "");
    localStorage.setItem("contact_id", "");
  }

  render() {
    console.log('render currentContactID index', this.state.currentContactID);
    return (
      <Fragment>
        <audio
          ref={(new_selected_play) => {
            this.new_selected_play = new_selected_play;
          }}
        >
          <source
            src={this.props.scheduleSoundUrl ? this.props.scheduleSoundUrl : "https://usealan.s3.us-east-2.amazonaws.com/assets/media/audio/alan-lco-sound.mp3"}
            type="audio/mpeg">
          </source>
        </audio>
        <button id="disconnectSocket" className="d-none" onClick={(e) => this.disconnectSocket(e)}></button>
        <RBT.Container className="main-container">
          <RBT.Row>
            <div className="col-md-12">
              <div className="live-chat-body">
                <ContactList
                  current_contact={this.state.currentContactID}
                  current_gym_owner={this.state.currentGymOwnerID}
                  settLeadFromLatestReplies={this.getLeadFromLatestReplies}
                  Socket={this.state.Socket}
                  isAutoAssigned={this.state.isAutoAssigned}
                  lco_id={this.state.lco_id}
                />

                {/*--- Start auto assign area --*/}
                <div className="middle-container">
                  <div className="main-chat-wrapper">
                    {
                      this.state.currentContactID ?
                        <Conversations
                          currentContactID={this.state.currentContactID}
                          currentGymOwnerID={this.state.currentGymOwnerID}
                          assignedContactID={this.state.assignedContactID}
                          assignedGymOwnerID={this.state.assignedGymOwnerID}
                          Socket={this.state.Socket}
                          isAutoAssigned={this.state.isAutoAssigned}
                          isAutoAssignable={this.state.isAutoAssignable}
                          pauseScheduleMessage={this.state.pauseScheduleMessage}
                          scheduleSoundUrl={this.state.scheduleSoundUrl}
                          newSelectedPlay={this.newSelectedPlay}
                        />
                        : <div className="emptyChatbox text-center">
                          {
                            (
                              this.state.isAutoAssignable ?
                                (
                                  this.state.rightContainerType === "autoAssign" || this.state.loadingConversation === true ?
                                    <div>
                                      <div id="preloader" aria-busy="true" aria-label="Loading, please wait." role="progressbar">
                                        <img className="icon-preload" src={require("../../Assets/images/alan_bot.png").default} alt='' />
                                      </div><br />
                                      <span>{this.state.autoAssigningText}</span>
                                    </div> :
                                    (
                                      this.state.rightContainerType === "autoAssignUnavailable" ?
                                        <div>
                                          <img src={require("../../Assets/images/usealan_logo.png").default} alt="choose lead" /><br />
                                          <span>No Lead Available</span>
                                        </div>
                                        :
                                        <div>
                                          <img src={require("../../Assets/images/usealan_logo.png").default} alt="choose lead" /><br />
                                          <span>Choose Lead</span>
                                        </div>
                                    )
                                ) :
                                <div>
                                  <img src={require("../../Assets/images/usealan_logo.png").default} alt="choose lead" /><br />
                                  <span>Auto Assign Turned Off</span>
                                </div>
                            )
                          }
                        </div>
                    }
                  </div>
                </div>
                {/*--- End auto assign area --*/}

              </div>
              {/* live-chat-body */}
            </div>
          </RBT.Row>
        </RBT.Container>
      </Fragment>
    );
  }
}

// export default Index;
Index.propTypes = {
  auth: PropTypes.object.isRequired,
  autoassign: PropTypes.func.isRequired,
  setLiveLeadCount: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    isMute: state.auth.isMute,
    isAutoAssignable: state.auth.isAutoAssignable,
    leadProcessStatus: state.auth.leadProcessStatus,
  };
}

export default connect(mapStateToProps, { autoassign, setLiveLeadCount })(Index);